import { useState } from "react";
import "./Footer.css";
import Verified from "../../../public/not-verified.png";
import { useSelector } from "react-redux";
import { getUserData, selectSite, selectSiteDomainName, selectwhatsappSupport } from "../../../../AsianExchangeSrc/utils/helper/commonSelectors";
import Popup1 from "../../../../CommonComponents/Popup/Popup1";
import { PrivacyPolicyContent } from "./PrivacyPolicyContent";
import { TermsAndConditionsContent } from "./TermsAndConditionsContent";
import { RulesAndRegulationsContent } from "./RuleAndRegulationsContent";
import { KycContent } from "./KycContent";
import { SelfExclusionPolicyContent } from "./SelfExclusionPolicyContent";
import { AboutUsContent } from "./AboutUsContent";
import { ResponsibleGamingContent } from "./ResponsibleGamingContent";

const Footer = () => {
  const siteDomainNane = useSelector(selectSiteDomainName());
  const siteDetails = useSelector(selectSite());
  const userData = useSelector(getUserData());
    const whatsappSupport = useSelector(selectwhatsappSupport())
    const IsLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const [footerPopup, setFooterPopup] = useState("");
  return (
    <>
      <footer className="footer">
        {/* Contact Section */}
        <div className="contact-section">
          <div className="contact-box">
            {(siteDetails.whatsappSupport || whatsappSupport) && <div className="contact-button cursor-pointer" onClick={() => { siteDetails.whatsappSupport || whatsappSupport ? window.open(`https://wa.me/${IsLoggedIn?whatsappSupport.replaceAll(" ", ""):siteDetails.whatsappSupport.replaceAll(" ", "")}`, "_blank") : null }}>Customer support1 | support2</div>
            }{(siteDetails.whatsappSupport || whatsappSupport) && <div className="contact-button cursor-pointer" onClick={() => { siteDetails.whatsappSupport || whatsappSupport ? window.open(`https://wa.me/${IsLoggedIn?whatsappSupport.replaceAll(" ", ""):siteDetails.whatsappSupport.replaceAll(" ", "")}`, "_blank") : null }}>WhatsApp 3 | WhatsApp 4</div>
            }
          </div>
          <div className="contact-button"></div>
          <div className="contact-box contact-box2">
            <div className="contact-button">Skype</div>
            <div className="contact-button">Email</div>
            <div className="contact-button">{siteDomainNane}</div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="disclaimer-section">
          <div className="disclaimer-logo">
            <img src={Verified} alt="Logo" />
          </div>
          <div>
            <p>
              {siteDomainNane || ""} is operated by Sky Infotech N.V. a limited liability
              company incorporated under the laws of Curacao with company
              Registration number 152377 with registered office at Abraham de
              Veerstraat 9 , Curacao P.O Box 3421 and is licensed and regulated by
              the Curacao authority as the regulatory body responsible holding a
              (Sub-license with License number 365/JAZ Sub-License GLH-
              OCCHKTW0707072017 granted on 6.07.2017).
            </p>
            <div className="disclaimer-contact">
              <div>

                <p>support@{siteDomainNane}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Links Section */}
        <div style={{ fontSize: 12 }} className="links-section">
          <button onClick={() => setFooterPopup("Privacy Policy")}>Privacy Policy</button> -<button onClick={() => setFooterPopup("Terms and Conditions")}>Terms and Conditions</button> -
          <button onClick={() => setFooterPopup("Rules and Regulations")}>Rules and Regulations</button> -<button onClick={() => setFooterPopup("KYC")}>KYC</button> -
          <button onClick={() => setFooterPopup("Responsible Gaming")}>Responsible Gaming</button> -<button onClick={() => setFooterPopup("About Us")}>About Us</button> -
          <button onClick={() => setFooterPopup("Self-exclusion Policy")}>Self-exclusion Policy</button>
        </div>
      </footer>


      {footerPopup === "Privacy Policy" && <Popup1 title="Privacy Policy" isOpen={footerPopup === "Privacy Policy"} onClose={() => setFooterPopup("")}>
        <PrivacyPolicyContent />
      </Popup1>}

      {footerPopup === "Terms and Conditions" && <Popup1 title="Terms and Conditions" isOpen={footerPopup === "Terms and Conditions"} onClose={() => setFooterPopup("")}>
        <TermsAndConditionsContent />
      </Popup1>}

      {footerPopup === "Rules and Regulations" && <Popup1 title="Rules and Regulations" isOpen={footerPopup === "Rules and Regulations"} onClose={() => setFooterPopup("")}>
        <RulesAndRegulationsContent />
      </Popup1>}

      {footerPopup === "KYC" && <Popup1 title="KYC" isOpen={footerPopup === "KYC"} onClose={() => setFooterPopup("")}>
        <KycContent />
      </Popup1>}

      {footerPopup === "Responsible Gaming" && <Popup1 title="Responsible Gaming" isOpen={footerPopup === "Responsible Gaming"} onClose={() => setFooterPopup("")}>
        <ResponsibleGamingContent />
      </Popup1>}

      {footerPopup === "About Us" && <Popup1 title="About Us" isOpen={footerPopup === "About Us"} onClose={() => setFooterPopup("")}>
        <AboutUsContent />
      </Popup1>}

      {footerPopup === "Self-exclusion Policy" && <Popup1 title="Self-exclusion Policy" isOpen={footerPopup === "Self-exclusion Policy"} onClose={() => setFooterPopup("")}>
        <SelfExclusionPolicyContent />
      </Popup1>}
    </>
  );
};

export default Footer;
